export const fallbackToEnglishExceptForFrench = (language: string) => ('fr' === language ? [] : ['en'])
